import { render, staticRenderFns } from "./PaymentVoucher.vue?vue&type=template&id=a4a20814&scoped=true&"
import script from "./PaymentVoucher.vue?vue&type=script&lang=js&"
export * from "./PaymentVoucher.vue?vue&type=script&lang=js&"
import style0 from "./PaymentVoucher.vue?vue&type=style&index=0&id=a4a20814&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4a20814",
  null
  
)

export default component.exports